import React from "react";
import { connect } from "react-redux";
import { CDN_BASE_IMAGES_URL } from "@constant";
import checkPattern from "../../assets/image/checkPattern.svg";
import moment from "moment";
import FacebookButton from "./components/facebook-button";
import LinkedinButton from "./components/linkedin-button";
import LocaleStrings from "@language";
import {
  useLocalStorage,
  LOCAL_STORAGE,
  LOGIN_SCREEN_NAME,
} from "@useLocalStorage";

function MainLogin({ eventData, deviceSize, eventsettings }) {
  const { setLocalStorage } = useLocalStorage();
  let eventIcon = `${CDN_BASE_IMAGES_URL}/${eventData?.eventicon}`;
  let eventdate = "-";
  if (eventData?.eventstartdate && eventData?.eventenddate) {
    const [y1, m1, d1] = eventData.eventstartdate.split("-");
    const [y2, m2, d2] = eventData.eventenddate.split("-");

    const formatDate = (date) => ({
      day: moment(date).format("ddd"),
      month: deviceSize?.isMobile
        ? moment(date).format("MM")
        : moment(date).format("MMM"),
      date: moment(date).format("DD"),
      year: moment(date).format("YYYY"),
    });

    const start = formatDate(eventData.eventstartdate);
    const end = formatDate(eventData.eventenddate);

    if (m1 === m2 && y1 === y2 && d1 === d2) {
      eventdate = `${start.day}, ${start.month} ${start.date}, ${y1}`;
    } else if (m1 === m2 && y1 === y2) {
      eventdate = `${start.day}, ${start.month} ${start.date} - ${end.day}, ${start.month} ${end.date}, ${y1}`;
    } else {
      eventdate =
        y1 === y2
          ? deviceSize?.isMobile
            ? `${start.date}/${start.month} - ${end.date}/${end.month}, ${y1}`
            : `${start.day}, ${start.month} ${start.date} - ${end.day}, ${end.month} ${end.date}, ${y1}`
          : deviceSize?.isMobile
          ? `${start.date}/${start.month}/${y1} - ${end.date}/${end.month}/${y2}`
          : `${start.day}, ${start.month} ${start.date}, ${y1} - ${end.day}, ${end.month} ${end.date}, ${y2}`;
    }
  }

  return (
    <div className="h-full bg-[#F9FAFB]">
      <div
        className="flex justify-center items-center h-full bg-top bg-no-repeat "
        style={{
          backgroundImage: `url(${checkPattern})`,
        }}
      >
        <div className="flex flex-col space-y-4 justify-center items-center h-full">
          <img
            className="event-icon rounded-lg shadow-md  border border-[#D0D5DD]"
            src={eventIcon}
            alt="eventicon"
          />
          <div className="text-2xl font-semibold">{eventData?.eventname}</div>
          <div className="text-md font-normal text-[#475467]">{eventdate}</div>
          <div className="w-[440px] p-8 space-y-5 mb-4 rounded-lg bg-white shadow-md border-[#F9FAFB]">
            <div className="text-sm font-medium text-center">
              {LocaleStrings.kSocialLoginText}
            </div>
            <LinkedinButton />
            <FacebookButton />
          </div>
          <div
            onClick={() =>
              setLocalStorage(
                LOCAL_STORAGE.LOGIN_SCREEN,
                LOGIN_SCREEN_NAME.PAYMENT_SCREEN
              )
            }
            className="text-sm font-medium leading-5 text-left underline decoration-solid cursor-pointer text-[#475467] hover:text-[#105EFB]"
          >
            {LocaleStrings.kSocialLoginSkipText}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    eventData: state.eventData,
    deviceSize: state.deviceSize,
    eventsettings: state.eventSettingsData,
  };
};

export default connect(mapStateToProps, {})(MainLogin);
